(function () {
  'use strict';

  angular
    .module('component.modify-cart-item', [])

    .component('buttonModifyCartItem', {
      require: {
        productCtrl: '?^^productDetail'
      },
      bindings: {
        size: '@?',
        btnClass: '@',
        isPrimary: '<',
        addToCartActive: '<',
        allowAddToCart: '<',
        titleAdd: '@?',
        titleAlert: '@?',
        titleModifyOk: '@?',
        tooltip: '@',
        modalCtrl: '<',
        device: '<'
      },
      templateUrl: 'component.modify-cart-item.tpl',
      /* @ngInject */
      controller: ["toastr", "AppService", "ModalService", function (toastr, AppService, ModalService) {
        var ctrl = this;

        ctrl.addToCart = function () {
          var products = ctrl.productCtrl.getProductsToAdd(ctrl.modalCtrl.quantity, 0);
          products[0].idLine = ctrl.modalCtrl.idLine;

          ctrl.modalCtrl.showLoader = true;
          AppService.addToCart(products)
            .then(function (response) {
              ctrl.modalCtrl.showLoader = false;
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
                toastr.success(ctrl.designation, ctrl.titleModifyOk, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_addtocart.tpl',
                    data: {
                      img: products[0].img
                    }
                  }
                });
                ModalService.close();
              } else {
                AppService.getTranslate()
                  .then(function (translate) {
                    toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              }
            });
        };

      }]
    });

})();
